import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, BoxIcon } from 'lucide-react';
interface ServiceCardProps {
  title: string;
  description: string;
  icon: BoxIcon;
  linkTo: string;
}
export function ServiceCard({
  title,
  description,
  icon: Icon,
  linkTo
}: ServiceCardProps) {
  return <div className="bg-white rounded-xl p-8 shadow-soft hover:shadow-card transition-all duration-300 group border border-gray-100 flex flex-col h-full" data-id="element-156">
      <div className="w-14 h-14 bg-cream rounded-lg flex items-center justify-center mb-6 group-hover:bg-light-blue group-hover:text-white transition-colors duration-300" data-id="element-157">
        <Icon className="w-7 h-7 text-navy group-hover:text-white transition-colors duration-300" data-id="element-158" />
      </div>
      <h3 className="text-xl font-montserrat text-navy mb-3" data-id="element-159">{title}</h3>
      <p className="text-gray-600 mb-6 flex-grow" data-id="element-160">{description}</p>
      <Link to={linkTo} className="inline-flex items-center text-steel-blue font-semibold hover:text-navy transition-colors mt-auto" data-id="element-161">
        Learn More{' '}
        <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-162" />
      </Link>
    </div>;
}